/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitFeedbackDto
 */
export interface SubmitFeedbackDto {
    /**
     * The ID of the treatment plan to submit feedback for
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    treatmentPlanId: string;
    /**
     * The feedback text
     * @type {string}
     * @memberof SubmitFeedbackDto
     */
    feedback: string;
}

/**
 * Check if a given object implements the SubmitFeedbackDto interface.
 */
export function instanceOfSubmitFeedbackDto(value: object): value is SubmitFeedbackDto {
    if (!('treatmentPlanId' in value) || value['treatmentPlanId'] === undefined) return false;
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    return true;
}

export function SubmitFeedbackDtoFromJSON(json: any): SubmitFeedbackDto {
    return SubmitFeedbackDtoFromJSONTyped(json, false);
}

export function SubmitFeedbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitFeedbackDto {
    if (json == null) {
        return json;
    }
    return {
        
        'treatmentPlanId': json['treatmentPlanId'],
        'feedback': json['feedback'],
    };
}

export function SubmitFeedbackDtoToJSON(json: any): SubmitFeedbackDto {
    return SubmitFeedbackDtoToJSONTyped(json, false);
}

export function SubmitFeedbackDtoToJSONTyped(value?: SubmitFeedbackDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'treatmentPlanId': value['treatmentPlanId'],
        'feedback': value['feedback'],
    };
}

